import { type Gateway, useGateway } from '@ad-lucy/gateway-provider';
import { getAppConfig } from '@modules/config/appConfig';

type MfOrganizationSettingsConfig = {
  API_ROOT: string;
  DD_ENV: string;
  IMG_URL: string;
  SUPPORTED_LANGUAGES: string;
  THEME_URL: string;
};

type MfOrganizationSettingsReturnProps = {
  gateway: Gateway;
  appConfig: MfOrganizationSettingsConfig;
};

const useMfOrganizationSettingsConfig =
  (): MfOrganizationSettingsReturnProps => {
    const gateway = useGateway();
    const appConfig = getAppConfig();

    return {
      gateway,
      appConfig: {
        API_ROOT: appConfig.API_ROOT,
        DD_ENV: appConfig.DD_ENV,
        IMG_URL: appConfig.IMG_URL,
        SUPPORTED_LANGUAGES: appConfig.SUPPORTED_LANGUAGES,
        THEME_URL: appConfig.THEME_URL,
      },
    };
  };

export { useMfOrganizationSettingsConfig };
